/**
 * useShareUrl — copy the current page URL to clipboard.
 *
 * Encapsulates the handleCopyUrl pattern duplicated across all 4 Builder components.
 */
import { useCallback } from 'react';
import { toast } from '@/components/ui/Toast';

/**
 * Returns a stable callback that copies `window.location.href` to the clipboard
 * and shows a success/error toast.
 */
export function useShareUrl() {
  return useCallback(() => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => toast.success('URL copied to clipboard'))
      .catch(() => toast.error('Failed to copy URL'));
  }, []);
}
